// @flow
import React, { useContext } from 'react';
import { DeleteRenderer } from '@components/views/grid-utils/renderers';
import { SPStreamingProjectContext } from '@streaming-projects/sp-page/contexts/SPStreamingProjectContext';
import { FRONT_END_DISPLAY_NAMES } from '@streaming-projects/enums';
import { SPTableFlowWorkloadDeleteWarningModal } from '@streaming-projects/workloads/tableflow-workloads/delete/SPTableFlowWorkloadDeleteWarningModal';

export const SPTableFlowWorkloadDeleteRenderer = ({ data }) => {
  const spStreamingProjectData = useContext(SPStreamingProjectContext);
  return (
    <DeleteRenderer>
      {(isDeleteModalOpen, setDeleteModalOpen) => {
        return (
          <SPTableFlowWorkloadDeleteWarningModal
            isOpen={isDeleteModalOpen}
            onClose={() => setDeleteModalOpen(false)}
            spVersion={spStreamingProjectData?.sp?.version}
            tableFlowWorkloadId={data[FRONT_END_DISPLAY_NAMES.WORKLOAD_ID]}
            tableFlowWorkloadName={data[FRONT_END_DISPLAY_NAMES.WORKLOAD_NAME]}
            tableFlowWorkloadResourceId={data[FRONT_END_DISPLAY_NAMES.RESOURCE_ID]}
          />
        );
      }}
    </DeleteRenderer>
  );
};
